export default {
  "title": {
    "travels": "Trips",
    "mainIndicators": "Main behavioral indicators",
    "dailyBehaviorGrade": "Daily behavioural grade",
    "travelDetail": "Trip behavioral grade detail",
    "travelMainIndicators": "Trip indicators",
    "drivers": "drivers",
    "driverSleeps": "Drowsiness events",
    "team": "EQUIPMENT"
  },
  "labels": {
    "behaviorGrade": "Behavioral grade",
    "average": "Average"
  },
  "graphTooltip": {
    "behaviorGrade": "Daily grade"
  },
  "buttons": {
    "travelDetail": "Trip detail"
  },
  "table": {
    "travel": "Trip",
    "grade": "Behavioral grade"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/behavior/driverBehavior.js